<div class="mt-md-3 container-fluid">
  <div class="row">
    <div class="col-12 col-md-10 offset-md-1">

      <!-- Header -->
      <div class="d-flex align-items-center mb-3">
        <a routerLink="/console/cobranza" class="btn btn-outline-secondary btn-sm me-3">
          <i class="fas fa-arrow-left"></i>
        </a>
        <div>
          <h5 class="mb-0 fw-bold text-dark">Consultas BDV</h5>
          <small class="text-secondary">Banco de Venezuela - Consultas de solo lectura</small>
        </div>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab==='movimientos'" (click)="setTab('movimientos')" role="button">
            <i class="fas fa-exchange-alt me-1"></i> Movimientos
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled text-muted" style="cursor:not-allowed;opacity:0.5;">
            <i class="fas fa-wallet me-1"></i> Saldo <span class="badge bg-secondary ms-1" style="font-size:0.6rem;">Coming soon</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab==='notificacion'" (click)="setTab('notificacion')" role="button">
            <i class="fas fa-search me-1"></i> Buscar Notificaci&oacute;n
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab==='bitacora'" (click)="setTab('bitacora')" role="button">
            <i class="fas fa-clipboard-list me-1"></i> Bit&aacute;cora
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab==='boton-pagos'" (click)="setTab('boton-pagos')" role="button">
            <i class="fas fa-credit-card me-1"></i> Bot&oacute;n de Pagos
          </a>
        </li>
      </ul>

      <!-- Error -->
      <div *ngIf="errorMsg" class="alert alert-warning mt-1">
        <i class="fas fa-exclamation-triangle text-danger me-2"></i>
        {{ errorMsg }}
      </div>

      <!-- Loading -->
      <ng-container *ngIf="loading">
        <div class="w-100 text-center mt-4">
          <img src="./assets/public/images/loading.gif" alt="">
        </div>
      </ng-container>

      <!-- ========== TAB MOVIMIENTOS ========== -->
      <div *ngIf="activeTab==='movimientos'">
        <div class="mt-2 mb-4 p-3 bg-body rounded shadow-sm">
          <div class="row g-3 align-items-end">
            <div class="col-md-4">
              <div class="small text-secondary">Cuenta</div>
              <select class="form-select" [(ngModel)]="movCuenta">
                <option *ngFor="let c of CUENTAS_BDV" [value]="c.numero">{{ c.numero }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <div class="small text-secondary">Fecha Inicio</div>
              <input type="date" class="form-control" [(ngModel)]="movFechaIni">
            </div>
            <div class="col-md-3">
              <div class="small text-secondary">Fecha Fin</div>
              <input type="date" class="form-control" [(ngModel)]="movFechaFin">
            </div>
            <div class="col-md-2">
              <button class="btn btn-primary w-100" (click)="consultarMovimientos()" [disabled]="loading">
                Consultar
              </button>
            </div>
          </div>
        </div>

        <!-- Resultados movimientos -->
        <ng-container *ngIf="movResultado && !loading">

          <!-- Barra de filtro y totales -->
          <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
            <span class="small text-secondary">{{ movFiltrados.length }} movimientos <span *ngIf="movFiltro">(filtrados de {{ movTodos.length }})</span></span>
            <div class="d-flex align-items-center">
              <input type="text" class="form-control form-control-sm me-2" [(ngModel)]="movFiltro" (ngModelChange)="filtrarMovimientos()" placeholder="Buscar..." style="width:200px;">
              <button class="btn btn-sm btn-outline-secondary me-1" (click)="exportarMovimientosXlsx()" title="Descargar Excel">
                <i class="fas fa-file-excel"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary me-2" (click)="exportarMovimientosPdf()" title="Imprimir / PDF">
                <i class="fas fa-file-pdf"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary me-1" (click)="movIrPagina(movPage - 1)" [disabled]="movPage <= 1">
                <i class="fas fa-chevron-left"></i>
              </button>
              <span class="small text-secondary mx-1">{{ movPage }}/{{ movTotalPages || 1 }}</span>
              <button class="btn btn-sm btn-outline-secondary" (click)="movIrPagina(movPage + 1)" [disabled]="movPage >= movTotalPages">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <ng-container *ngIf="movFiltrados.length > 0">
            <ng-container *ngFor="let mov of movPaginados">
              <div class="mt-1 mb-1 p-3 bg-body rounded shadow-sm">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center">
                      <i class="fas me-2" [class.fa-arrow-down]="mov.mov==='CREDITO'" [class.fa-arrow-up]="mov.mov==='DEBITO'" [class.text-success]="mov.mov==='CREDITO'" [class.text-danger]="mov.mov==='DEBITO'"></i>
                      <div>
                        <div class="text-dark fw-bold small">{{ mov.descripcion || mov.mov }}</div>
                        <div class="text-secondary" style="font-size:0.75rem;">{{ mov.fecha }} &middot; Ref: {{ mov.referencia }}</div>
                        <div class="text-secondary" style="font-size:0.72rem;" *ngIf="mov.observacion">{{ mov.observacion }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="text-end ms-3" style="min-width:140px;">
                    <div class="fw-bold" [class.text-success]="mov.mov==='CREDITO'" [class.text-danger]="mov.mov==='DEBITO'">
                      {{ mov.mov === 'CREDITO' ? '+' : '' }}{{ mov.importe }}
                    </div>
                    <div class="text-secondary" style="font-size:0.75rem;">Saldo: {{ mov.saldo }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- Empty state movimientos -->
          <div *ngIf="movFiltrados.length === 0 && movTodos.length > 0" class="text-center py-4">
            <span class="text-secondary small">No hay movimientos que coincidan con "{{ movFiltro }}"</span>
          </div>

          <div *ngIf="movTodos.length === 0" class="text-center py-5">
            <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
              <i class="fas fa-exchange-alt text-secondary"></i>
            </div>
            <div class="text-dark fw-medium">No se encontraron movimientos</div>
            <div class="text-secondary small">No hay movimientos para el rango de fechas indicado</div>
          </div>
        </ng-container>

        <!-- Empty state inicial -->
        <div *ngIf="!movResultado && !loading && !errorMsg" class="text-center py-5">
          <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
            <i class="fas fa-exchange-alt text-secondary"></i>
          </div>
          <div class="text-secondary small">Ingrese los datos y presione Consultar</div>
        </div>
      </div>

      <!-- ========== TAB SALDO ========== -->
      <div *ngIf="activeTab==='saldo'">
        <div class="mt-2 mb-4 p-3 bg-body rounded shadow-sm">
          <div class="row g-3 align-items-end">
            <div class="col-md-8">
              <div class="small text-secondary">Cuenta</div>
              <select class="form-select" [(ngModel)]="saldoCuenta">
                <option *ngFor="let c of CUENTAS_BDV" [value]="c.numero">{{ c.numero }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <button class="btn btn-primary w-100" (click)="consultarSaldo()" [disabled]="loading">
                Consultar Saldo
              </button>
            </div>
          </div>
        </div>

        <!-- Resultado saldo -->
        <ng-container *ngIf="saldoResultado && !loading">
          <div class="mt-2 p-3 bg-body rounded shadow-sm">
            <div class="d-flex text-dark pt-2">
              <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                <div class="d-flex justify-content-between">
                  <span class="text-secondary">Cuenta Principal</span>
                  <span class="fw-bold text-dark">{{ saldoResultado?.cuentaPrincipal }}</span>
                </div>
              </div>
            </div>
            <div class="d-flex text-dark pt-3">
              <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                <div class="d-flex justify-content-between">
                  <span class="text-secondary">Saldo Retenido Total</span>
                  <span class="fw-bold text-dark">{{ saldoResultado?.ppalSdoRetTot }}</span>
                </div>
              </div>
            </div>
            <div class="d-flex text-dark pt-3">
              <div class="pb-3 mb-0 small lh-sm w-100">
                <div class="d-flex justify-content-between">
                  <span class="text-secondary">Saldo Final</span>
                  <span class="fw-bold text-primary" style="font-size: 1.1rem;">{{ saldoResultado?.ppalSdoFinal }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Empty state saldo -->
        <div *ngIf="!saldoResultado && !loading && !errorMsg" class="text-center py-5">
          <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
            <i class="fas fa-wallet text-secondary"></i>
          </div>
          <div class="text-secondary small">Ingrese la cuenta y presione Consultar Saldo</div>
        </div>
      </div>

      <!-- ========== TAB BUSCAR NOTIFICACION ========== -->
      <div *ngIf="activeTab==='notificacion'">
        <div class="mt-2 mb-4 p-3 bg-body rounded shadow-sm">
          <div class="row g-3 align-items-end">
            <div class="col-md-4">
              <div class="small text-secondary">Monto</div>
              <input type="number" class="form-control" [(ngModel)]="notifMonto" placeholder="50.00" step="0.01">
            </div>
            <div class="col-md-4">
              <div class="small text-secondary">Referencia (&uacute;ltimos 6 d&iacute;gitos)</div>
              <input type="text" class="form-control" [(ngModel)]="notifReferencia" maxlength="6" placeholder="125507">
            </div>
            <div class="col-md-4">
              <button class="btn btn-primary w-100" (click)="buscarNotificacion()" [disabled]="loading">
                Buscar
              </button>
            </div>
          </div>
        </div>

        <!-- Resultados notificacion -->
        <ng-container *ngIf="notifResultado && !loading">
          <div class="small text-secondary mb-2">
            Resultados encontrados: <span class="fw-bold text-dark">{{ notifResultado?.total || 0 }}</span>
          </div>

          <ng-container *ngIf="notifResultado?.results?.length > 0">
            <ng-container *ngFor="let n of notifResultado?.results">
              <div class="mt-2 mb-2 p-3 bg-body rounded shadow-sm">
                <div class="row">
                  <div class="col-6 col-md-3">
                    <div class="small text-secondary">Tel&eacute;fono Pagador</div>
                    <div class="fw-bold text-primary cursor-pounter">{{ n.telefono_pagador }}</div>
                  </div>
                  <div class="col-6 col-md-2">
                    <div class="small text-secondary">Monto</div>
                    <div class="fw-bold text-dark">{{ n.monto }}</div>
                  </div>
                  <div class="col-6 col-md-2 mt-2 mt-md-0">
                    <div class="small text-secondary">Referencia</div>
                    <div class="text-dark">{{ n.referencia }}</div>
                  </div>
                  <div class="col-6 col-md-2 mt-2 mt-md-0">
                    <div class="small text-secondary">Fecha</div>
                    <div class="text-dark">{{ n.fecha | date:'dd/MM/yyyy HH:mm' }}</div>
                  </div>
                  <div class="col-6 col-md-3 mt-2 mt-md-0 text-md-end">
                    <div class="small text-secondary">Status</div>
                    <span class="badge rounded-pill" [class.text-bg-success]="n.status==='applied'" [class.text-bg-warning]="n.status==='received'" [class.text-bg-info]="n.status==='processed'">
                      {{ n.status }}
                    </span>
                  </div>
                </div>
                <hr class="my-2">
                <div class="row">
                  <div class="col-6 col-md-3">
                    <div class="small text-secondary">C&eacute;dula</div>
                    <div class="text-dark small">{{ n.cedula }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="small text-secondary">Banco Origen</div>
                    <div class="text-dark small">{{ n.banco_origen }}</div>
                  </div>
                  <div class="col-6 col-md-3 mt-2 mt-md-0">
                    <div class="small text-secondary">Tel&eacute;fono Comercio</div>
                    <div class="text-dark small">{{ n.telefono_comercio }}</div>
                  </div>
                  <div class="col-6 col-md-3 mt-2 mt-md-0">
                    <div class="small text-secondary">Ref. Completa</div>
                    <div class="text-dark small">{{ n.referencia_completa }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- Empty state notificacion sin resultados -->
          <div *ngIf="notifResultado?.results?.length === 0" class="text-center py-5">
            <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
              <i class="fas fa-search text-secondary"></i>
            </div>
            <div class="text-dark fw-medium">No se encontraron notificaciones</div>
            <div class="text-secondary small">No hay notificaciones con ese monto y referencia</div>
          </div>
        </ng-container>

        <!-- Empty state notificacion inicial -->
        <div *ngIf="!notifResultado && !loading && !errorMsg" class="text-center py-5">
          <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
            <i class="fas fa-search text-secondary"></i>
          </div>
          <div class="text-secondary small">Ingrese el monto y la referencia para buscar</div>
        </div>
      </div>

      <!-- ========== TAB BITACORA ========== -->
      <div *ngIf="activeTab==='bitacora'">
        <div class="mt-2 mb-4 p-3 bg-body rounded shadow-sm">
          <div class="row g-3 align-items-end">
            <div class="col-6 col-md-2">
              <div class="small text-secondary">Fecha Inicio</div>
              <input type="date" class="form-control" [(ngModel)]="bitFechaInicio">
            </div>
            <div class="col-6 col-md-2">
              <div class="small text-secondary">Fecha Fin</div>
              <input type="date" class="form-control" [(ngModel)]="bitFechaFin">
            </div>
            <div class="col-6 col-md-2">
              <div class="small text-secondary">Tipo</div>
              <select class="form-select" [(ngModel)]="bitTipo">
                <option value="">Todos</option>
                <option value="movimientos">Movimientos</option>
                <option value="saldo">Saldo</option>
                <option value="buscar_notificacion">Notificaci&oacute;n</option>
              </select>
            </div>
            <div class="col-6 col-md-2">
              <div class="small text-secondary">Usuario</div>
              <input type="text" class="form-control" [(ngModel)]="bitUsuario" placeholder="Ej: Mario">
            </div>
            <div class="col-6 col-md-2">
              <div class="small text-secondary">Referencia</div>
              <input type="text" class="form-control" [(ngModel)]="bitReferencia" placeholder="Ej: 345634">
            </div>
            <div class="col-6 col-md-2">
              <button class="btn btn-primary w-100" (click)="consultarBitacora(1)" [disabled]="loading">
                Buscar
              </button>
            </div>
          </div>
        </div>

        <!-- Resultados bitacora -->
        <ng-container *ngIf="bitResultado && !loading">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="small text-secondary">{{ bitTotal }} registros - P&aacute;gina {{ bitPage }} de {{ bitTotalPages }}</span>
            <div>
              <button class="btn btn-sm btn-outline-secondary me-1" (click)="consultarBitacora(bitPage - 1)" [disabled]="bitPage <= 1">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary" (click)="consultarBitacora(bitPage + 1)" [disabled]="bitPage >= bitTotalPages">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <ng-container *ngIf="bitResultado?.length > 0">
            <ng-container *ngFor="let reg of bitResultado">
              <div class="mt-2 mb-2 p-3 bg-body rounded shadow-sm cursor-pounter" (click)="verDetalle(reg)">
                <div class="row align-items-center">
                  <div class="col-6 col-md-3">
                    <div class="small text-secondary">Fecha/Hora</div>
                    <div class="text-dark small">{{ reg.fecha | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                  </div>
                  <div class="col-6 col-md-2">
                    <div class="small text-secondary">Usuario</div>
                    <div class="fw-bold text-dark small text-capitalize">{{ reg.usuario_nombre }}</div>
                  </div>
                  <div class="col-4 col-md-2 mt-2 mt-md-0">
                    <div class="small text-secondary">Tipo</div>
                    <span class="badge rounded-pill bg-dark">{{ getTipoLabel(reg.tipo_consulta) }}</span>
                  </div>
                  <div class="col-4 col-md-2 mt-2 mt-md-0">
                    <div class="small text-secondary">IP</div>
                    <div class="text-secondary small">{{ reg.ip }}</div>
                  </div>
                  <div class="col-4 col-md-2 mt-2 mt-md-0">
                    <div class="small text-secondary">Resultado</div>
                    <span class="badge rounded-pill" [class.text-bg-success]="reg.success" [class.text-bg-danger]="!reg.success">
                      {{ reg.success ? 'OK' : 'Error' }}
                    </span>
                  </div>
                  <div class="col-12 col-md-1 mt-2 mt-md-0 text-end">
                    <i class="fas text-secondary" [class.fa-chevron-down]="bitDetalleSeleccionado !== reg" [class.fa-chevron-up]="bitDetalleSeleccionado === reg"></i>
                  </div>
                </div>

                <!-- Detalle expandible -->
                <ng-container *ngIf="bitDetalleSeleccionado === reg">
                  <hr class="my-2">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="small fw-bold text-dark mb-1">Request</div>
                      <pre class="bg-white p-2 rounded border small mb-0" style="white-space:pre-wrap;word-break:break-all;">{{ reg.request_body | json }}</pre>
                    </div>
                    <div class="col-md-6" *ngIf="reg.response_body">
                      <div class="small fw-bold text-dark mb-1">Response ({{ reg.response_total }} resultados)</div>
                      <pre class="bg-white p-2 rounded border small mb-0" style="max-height:300px;overflow-y:auto;white-space:pre-wrap;word-break:break-all;">{{ reg.response_body | json }}</pre>
                    </div>
                    <div class="col-md-6 mt-2 mt-md-0" *ngIf="!reg.response_body && !reg.error_message">
                      <div class="small fw-bold text-dark mb-1">Response</div>
                      <span class="text-secondary small">No se almacena para este tipo de consulta</span>
                    </div>
                    <div class="col-md-6 mt-2 mt-md-0" *ngIf="reg.error_message">
                      <div class="small fw-bold text-danger mb-1">Error</div>
                      <pre class="bg-white p-2 rounded border small text-danger mb-0" style="white-space:pre-wrap;word-break:break-all;">{{ reg.error_message }}</pre>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- Empty state bitacora sin resultados -->
          <div *ngIf="bitResultado?.length === 0" class="text-center py-5">
            <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
              <i class="fas fa-clipboard-list text-secondary"></i>
            </div>
            <div class="text-dark fw-medium">No se encontraron registros</div>
            <div class="text-secondary small">No hay registros en la bit&aacute;cora para los filtros seleccionados</div>
          </div>
        </ng-container>

        <!-- Empty state bitacora inicial -->
        <div *ngIf="!bitResultado && !loading && !errorMsg" class="text-center py-5">
          <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
            <i class="fas fa-clipboard-list text-secondary"></i>
          </div>
          <div class="text-secondary small">Presione Buscar para consultar la bit&aacute;cora</div>
        </div>
      </div>

      <!-- ========== TAB BOTÓN DE PAGOS BP ========== -->
      <div *ngIf="activeTab==='boton-pagos'">

        <!-- Sub-tabs -->
        <ul class="nav nav-pills mb-3">
          <li class="nav-item">
            <a class="nav-link" [class.active]="bpSubTab==='individual'" (click)="setBpSubTab('individual')" role="button">
              <i class="fas fa-search me-1"></i> Consulta Individual
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="bpSubTab==='reclamo'" (click)="setBpSubTab('reclamo')" role="button">
              <i class="fas fa-user-shield me-1"></i> Reclamo Cliente
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="bpSubTab==='liquidacion'" (click)="setBpSubTab('liquidacion')" role="button">
              <i class="fas fa-file-excel me-1"></i> Liquidaci&oacute;n Bancaria
            </a>
          </li>
        </ul>

        <!-- ===== Sub-tab: Consulta Individual ===== -->
        <div *ngIf="bpSubTab==='individual'">
          <div class="mt-2 mb-4 p-3 bg-body rounded shadow-sm">
            <div class="row g-3 align-items-end">
              <div class="col-md-6">
                <div class="small text-secondary">N&uacute;mero de Referencia Afiliado</div>
                <input type="number" class="form-control" [(ngModel)]="bpTxNumber" placeholder="Ej: 3348921" />
              </div>
              <div class="col-md-3">
                <button class="btn btn-primary w-100" (click)="bpConsultarTx()" [disabled]="bpConsultando || !bpTxNumber">
                  <i class="fas fa-search me-1"></i>
                  <span *ngIf="!bpConsultando">Consultar</span>
                  <span *ngIf="bpConsultando">Consultando...</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Resultado -->
          <div *ngIf="bpResultado" class="p-3 bg-body rounded shadow-sm mb-3">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <div class="fw-bold text-dark">
                  Referencia afiliado:
                  <a href="javascript:void(0)"
                     class="text-decoration-none text-primary"
                     title="Click para copiar"
                     (click)="bpCopyToClipboard(bpResultado.transactionNumber + '', 'Referencia afiliado')">
                    {{ bpResultado.transactionNumber }}
                    <i class="fas fa-copy ms-1" style="font-size:0.7rem;"></i>
                  </a>
                </div>
                <div class="small text-secondary" *ngIf="bpResultado.personName">
                  {{ bpResultado.personName }}
                  <span *ngIf="bpResultado.personIdentity">
                    — C.I.
                    <a href="javascript:void(0)"
                       class="text-decoration-none text-primary"
                       title="Click para copiar"
                       (click)="bpCopyToClipboard(bpResultado.personIdentity, 'Cédula')">
                      {{ bpResultado.personIdentity }}
                      <i class="fas fa-copy ms-1" style="font-size:0.7rem;"></i>
                    </a>
                  </span>
                </div>
              </div>
              <span class="badge rounded-pill" [ngClass]="bpStatusBadge(bpResultado.status).cls">
                {{ bpStatusBadge(bpResultado.status).label }}
              </span>
            </div>
            <div class="row g-2 small">
              <div class="col-md-4" *ngIf="bpResultado.amount != null">
                <span class="text-secondary">Monto:</span> <strong>{{ bpResultado.amount | number:'1.2-2' }} Bs.</strong>
              </div>
              <div class="col-md-4" *ngIf="bpResultado.datePending">
                <span class="text-secondary">Fecha:</span> {{ bpResultado.datePending | date:'dd/MM/yyyy HH:mm' }}
              </div>
              <div class="col-md-4" *ngIf="bpResultado.paymentIdentity">
                <span class="text-secondary">C&eacute;d. pagador:</span> {{ bpResultado.paymentIdentity }}
              </div>
            </div>

            <div *ngIf="bpResultado.hasMultipleDocs" class="alert alert-warning small mt-2 mb-0 py-2">
              <i class="fas fa-info-circle me-1"></i>
              Se encontraron m&uacute;ltiples intentos para esta referencia (normal si el cliente reintent&oacute;).
              <span *ngIf="bpResultado.hasTrashDocs"> Incluye intentos descartados.</span>
            </div>

            <!-- Payment existente: info inline + botón Ver pago -->
            <div *ngIf="bpResultado.payment" class="mt-3 pt-3 border-top">
              <div class="d-flex justify-content-between align-items-center">
                <div class="small">
                  <div><span class="text-secondary">C&oacute;digo de pago:</span> <strong>{{ bpResultado.payment.code }}</strong></div>
                  <div>
                    <span class="text-secondary">Estado:</span>
                    <span *ngIf="bpResultado.payment.reconciled" class="badge text-bg-success">Conciliado</span>
                    <span *ngIf="!bpResultado.payment.reconciled" class="badge text-bg-warning">Por conciliar</span>
                  </div>
                  <div *ngIf="bpResultado.payment.counterValue">
                    <span class="text-secondary">Monto:</span>
                    {{ bpResultado.payment.counterValue | number:'1.2-2' }} Bs.
                    <span class="text-secondary ms-2">({{ bpResultado.payment.amount | number:'1.2-2' }} USD @ {{ bpResultado.payment.rate | number:'1.2-2' }})</span>
                  </div>
                </div>
                <button class="btn btn-outline-primary btn-sm"
                        (click)="bpOpenPaymentDetail(bpResultado.payment.code, bpResultado.personCode)"
                        [disabled]="bpLoadingDetail">
                  <i class="fas fa-eye me-1"></i> Ver detalle
                </button>
              </div>
              <div *ngIf="!bpResultado.payment.reconciled" class="alert alert-warning small mt-2 mb-0 py-1">
                <i class="fas fa-exclamation-circle me-1"></i>
                Este pago existe pero <strong>no est&aacute; conciliado</strong>. Debe revisarse desde la vista de pagos del cliente.
              </div>
            </div>

            <!-- Acciones PENDING -->
            <div *ngIf="bpResultado.status==='PENDING'" class="mt-3 pt-3 border-top d-flex gap-2 flex-wrap">
              <button *ngIf="!bpResultado.payment"
                      class="btn btn-outline-primary btn-sm"
                      (click)="bpVerificarBanco()"
                      [disabled]="bpVerificando">
                <i class="fas fa-university me-1"></i>
                <span *ngIf="!bpVerificando">Verificar con el banco</span>
                <span *ngIf="bpVerificando">Verificando...</span>
              </button>
              <!-- Registrar pago SOLO si el banco confirmó PaymentAccepted y aún no existe payment.
                   Evita que el ejecutivo intente registrar una tx donde el banco dijo BankNoInfo,
                   PaymentNotExecuted o PaymentRejected (casos sin débito). El backend igual
                   rechaza esos casos, pero esconder el botón evita confusión al leer la respuesta. -->
              <button *ngIf="!bpResultado.payment && bpVerificacion?.result === 'PaymentAccepted'"
                      class="btn btn-danger btn-sm"
                      (click)="bpCrearPago()"
                      [disabled]="bpRegistrando || bpVerificando">
                <i class="fas" [ngClass]="bpRegistrando ? 'fa-spinner fa-spin me-1' : 'fa-plus-circle me-1'"></i>
                <span *ngIf="!bpRegistrando">Registrar pago</span>
                <span *ngIf="bpRegistrando">Registrando...</span>
              </button>
              <button class="btn btn-outline-secondary btn-sm" (click)="bpVerHistorial()" [disabled]="bpHistorialLoading || bpRegistrando">
                <i class="fas fa-history me-1"></i> Ver historial de intentos
              </button>
            </div>

            <!-- Banner mientras se registra -->
            <div *ngIf="bpRegistrando" class="alert alert-info small mt-2 mb-0 py-2 d-flex align-items-center gap-2">
              <div class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></div>
              <div>
                <strong>Registrando pago...</strong> Verificando con el banco, creando pago y conciliando cuotas.
              </div>
            </div>

            <!-- Hint: banco no confirmó PaymentAccepted -->
            <div *ngIf="bpResultado.status==='PENDING' && !bpResultado.payment && bpVerificacion && bpVerificacion.result !== 'PaymentAccepted'"
                 class="alert alert-warning small mt-2 mb-0 py-2">
              <i class="fas fa-exclamation-triangle me-1"></i>
              El banco no confirmó <strong>PaymentAccepted</strong>
              <span *ngIf="bpVerificacion.result"> (respondió <strong>{{ bpVerificacion.result }}</strong>)</span><span *ngIf="!bpVerificacion.result"> (respuesta vacía — revisa el historial)</span>.
              Si intentas registrar el pago, el backend verificará nuevamente con el banco.
              <div *ngIf="bpVerificacion.msg || bpVerificacion.responseDescription" class="mt-1 text-secondary">
                {{ bpVerificacion.msg || bpVerificacion.responseDescription }}
              </div>

              <!-- Descarte manual: cuando banco confirma que NO hubo débito, ofrecer botón -->
              <div *ngIf="bpVerificacion.result === 'PaymentNotExecuted' || bpVerificacion.result === 'PaymentRejected'"
                   class="mt-2 pt-2 border-top d-flex align-items-center gap-2">
                <div *ngIf="bpDescartando" class="spinner-border spinner-border-sm text-danger" role="status"></div>
                <div *ngIf="bpDescartando">
                  <i class="fas fa-info-circle me-1 text-primary"></i>
                  Moviendo la transacción a TRASH...
                </div>
                <div *ngIf="!bpDescartando && bpResultado.status === 'PENDING'">
                  <i class="fas fa-info-circle me-1 text-primary"></i>
                  <strong>No hubo débito al cliente.</strong> Puedes descartar esta transacción.
                  <button class="btn btn-outline-danger btn-sm ms-2" (click)="bpDescartarTxManual()">
                    <i class="fas fa-trash me-1"></i> Descartar transacción
                  </button>
                </div>
                <div *ngIf="!bpDescartando && bpResultado.status === 'TRASH'">
                  <i class="fas fa-check-circle me-1 text-success"></i>
                  Transacción descartada (TRASH).
                </div>
              </div>
            </div>

            <!-- Botón "Ver historial" siempre disponible (también para COMPLETE) -->
            <div *ngIf="bpResultado.status !== 'PENDING'" class="mt-3 pt-3 border-top">
              <button class="btn btn-outline-secondary btn-sm" (click)="bpVerHistorial()" [disabled]="bpHistorialLoading">
                <i class="fas fa-history me-1"></i> Ver historial de intentos
              </button>
            </div>
          </div>

          <!-- Verificación banco -->
          <div *ngIf="bpVerificacion" class="p-3 bg-body rounded shadow-sm mb-3">
            <div class="fw-bold text-dark mb-2">
              <i class="fas fa-university me-1 text-primary"></i> Respuesta del banco
            </div>
            <div class="small">
              <div><span class="text-secondary">Resultado:</span> <strong>{{ bpVerificacion.result }}</strong></div>
              <div *ngIf="bpVerificacion.detail?.authorizationCode">
                <span class="text-secondary">C&oacute;digo autorizaci&oacute;n:</span> {{ bpVerificacion.detail.authorizationCode }}
              </div>
              <div *ngIf="bpVerificacion.detail?.transactionId">
                <span class="text-secondary">ID transacci&oacute;n banco:</span> {{ bpVerificacion.detail.transactionId }}
              </div>
              <div *ngIf="bpVerificacion.detail?.amount != null">
                <span class="text-secondary">Monto banco:</span> {{ bpVerificacion.detail.amount | number:'1.2-2' }} Bs.
              </div>
              <div *ngIf="bpVerificacion.detail?.createdOn">
                <span class="text-secondary">Fecha banco:</span> {{ bpVerificacion.detail.createdOn }}
              </div>
              <div *ngIf="bpVerificacion.msg" class="mt-1 text-secondary">{{ bpVerificacion.msg }}</div>
            </div>
          </div>

          <!-- Banco no respondió (timeout/red) -->
          <div *ngIf="bpVerificacionError && !bpVerificacion && bpResultado" class="alert alert-warning small mb-3 py-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            No se pudo consultar al banco: {{ bpVerificacionError }}.
            La foto de kredit mostrada arriba puede no reflejar el estado actual del banco.
          </div>

          <!-- Resultado del registro de pago -->
          <div *ngIf="bpRegistroResult" class="p-3 bg-body rounded shadow-sm mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="fw-bold text-dark">Resultado del registro</div>
                <div class="small text-secondary" *ngIf="bpRegistroResult.reason">{{ bpRegistroResult.reason }}</div>
                <div class="small" *ngIf="bpRegistroResult.paymentCode">
                  C&oacute;digo: <strong>{{ bpRegistroResult.paymentCode }}</strong>
                  <span *ngIf="bpRegistroResult.invoicesPending != null"> — {{ bpRegistroResult.invoicesPending }} cuota(s) conciliada(s)</span>
                </div>
              </div>
              <span class="badge rounded-pill" [ngClass]="bpStatusBadge(bpRegistroResult.status).cls">
                {{ bpStatusBadge(bpRegistroResult.status).label }}
              </span>
            </div>
          </div>

          <!-- Empty state -->
          <div *ngIf="!bpResultado && !bpConsultando && !errorMsg" class="text-center py-5">
            <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
              <i class="fas fa-credit-card text-secondary"></i>
            </div>
            <div class="text-dark fw-medium">Consulta el estado de una transacci&oacute;n</div>
            <div class="text-secondary small">Ingresa el n&uacute;mero de Referencia Afiliado del Bot&oacute;n de Pagos</div>
          </div>
        </div>

        <!-- ===== Sub-tab: Reclamo Cliente ===== -->
        <div *ngIf="bpSubTab==='reclamo'">
          <div class="mt-2 mb-3 p-3 bg-body rounded shadow-sm">
            <div class="small text-secondary mb-2">
              Cuando un cliente reporta que le debitaron pero no le aparece el pago. Busca por cédula, monto y/o fechas.
              La cédula del pagador (quien pone la tarjeta) puede ser diferente a la del titular del crédito.
            </div>
            <div class="row g-3 align-items-end">
              <div class="col-md-4">
                <div class="small text-secondary">Cédula de quien pagó (tarjeta)</div>
                <input type="text" class="form-control" [(ngModel)]="bpFiltroCedulaPagador" placeholder="V28471657" />
              </div>
              <div class="col-md-4">
                <div class="small text-secondary">Cédula del titular CrediTotal</div>
                <input type="text" class="form-control" [(ngModel)]="bpFiltroCedulaUsuario" placeholder="V12345678" />
              </div>
              <div class="col-md-4">
                <div class="small text-secondary">Monto exacto (Bs.)</div>
                <input type="number" step="0.01" class="form-control" [(ngModel)]="bpFiltroMonto" placeholder="2531.57" />
              </div>
              <div class="col-md-3">
                <div class="small text-secondary">Monto mínimo</div>
                <input type="number" step="0.01" class="form-control" [(ngModel)]="bpFiltroMontoMin" placeholder="2400" />
              </div>
              <div class="col-md-3">
                <div class="small text-secondary">Monto máximo</div>
                <input type="number" step="0.01" class="form-control" [(ngModel)]="bpFiltroMontoMax" placeholder="2600" />
              </div>
              <div class="col-md-3">
                <div class="small text-secondary">Desde</div>
                <input type="date" class="form-control" [(ngModel)]="bpFiltroFechaDesde" />
              </div>
              <div class="col-md-3">
                <div class="small text-secondary">Hasta</div>
                <input type="date" class="form-control" [(ngModel)]="bpFiltroFechaHasta" />
              </div>
              <div class="col-md-8 d-flex gap-2">
                <button class="btn btn-primary" (click)="bpBuscarReclamo()" [disabled]="bpBuscando">
                  <i class="fas fa-search me-1"></i>
                  <span *ngIf="!bpBuscando">Buscar</span>
                  <span *ngIf="bpBuscando">Buscando...</span>
                </button>
                <button class="btn btn-outline-secondary" (click)="bpLimpiarReclamo()" [disabled]="bpBuscando">
                  <i class="fas fa-eraser me-1"></i> Limpiar
                </button>
              </div>
            </div>
          </div>

          <!-- Resultados de búsqueda -->
          <div *ngIf="bpBusquedaResults.length" class="mb-3">
            <div class="small text-secondary mb-2">
              {{ bpBusquedaResults.length }} resultado(s). Click en una fila para ir a consulta individual.
            </div>
            <div class="list-group">
              <a *ngFor="let r of bpBusquedaResults" class="list-group-item list-group-item-action"
                 (click)="bpSeleccionarDeReclamo(r.transactionNumber)" style="cursor:pointer;">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <div class="fw-medium">
                      {{ r.personName || 'Sin cliente' }}
                      <span class="text-secondary small ms-2" *ngIf="r.personIdentity">{{ r.personIdentity }}</span>
                    </div>
                    <div class="small text-secondary">
                      Ref {{ r.transactionNumber }} — {{ r.datePending | date:'dd/MM/yyyy HH:mm' }}
                      <span *ngIf="r.paymentIdentity !== r.personIdentity && r.paymentIdentity" class="ms-2">
                        · pagador: {{ r.paymentIdentity }}
                      </span>
                    </div>
                  </div>
                  <div class="text-end">
                    <div class="fw-medium">{{ r.amount | number:'1.2-2' }} Bs.</div>
                    <span class="badge rounded-pill mt-1" [ngClass]="bpStatusBadge(r.status).cls">
                      {{ bpStatusBadge(r.status).label }}
                    </span>
                    <div class="small text-success mt-1" *ngIf="r.paymentReconciled">
                      <i class="fas fa-check-circle me-1"></i> Conciliado
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <!-- Empty state con mensaje del servidor -->
          <div *ngIf="!bpBusquedaResults.length && !bpBuscando" class="text-center py-5">
            <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
              <i class="fas fa-user-shield text-secondary"></i>
            </div>
            <div class="text-dark fw-medium" *ngIf="!bpBusquedaMsg">Ingresa filtros para buscar transacciones</div>
            <div class="text-dark fw-medium" *ngIf="bpBusquedaMsg">{{ bpBusquedaMsg }}</div>
            <div class="text-secondary small">Usa cédula, monto y/o fechas para encontrar el reclamo del cliente</div>
          </div>
        </div>

        <!-- ===== Sub-tab: Liquidación Bancaria ===== -->
        <div *ngIf="bpSubTab==='liquidacion'">
          <div class="mt-2 mb-4 p-3 bg-body rounded shadow-sm">
            <div class="small text-secondary mb-2">
              Carga el archivo de liquidaci&oacute;n del banco para verificar cu&aacute;les pagos est&aacute;n registrados en el sistema.
            </div>
            <div class="row g-3 align-items-end">
              <div class="col-md-6">
                <label class="btn btn-outline-secondary w-100 mb-0">
                  <i class="fas fa-file-excel me-1"></i>
                  <span *ngIf="!bpArchivoNombre">Seleccionar archivo Excel</span>
                  <span *ngIf="bpArchivoNombre">{{ bpArchivoNombre }}</span>
                  <input type="file" accept=".xlsx,.xls,.csv" (change)="bpOnArchivoSeleccionado($event)" hidden />
                </label>
              </div>
              <div class="col-md-3">
                <button class="btn btn-primary w-100" (click)="bpCruzarConKredit()"
                        [disabled]="bpCruzando || !bpFilasParsed.length">
                  <i class="fas fa-sync-alt me-1"></i>
                  <span *ngIf="!bpCruzando">Cruzar con el sistema</span>
                  <span *ngIf="bpCruzando">Cruzando...</span>
                </button>
              </div>
              <div class="col-md-3" *ngIf="bpFilasParsed.length">
                <div class="small text-secondary">Detectadas</div>
                <span class="badge rounded-pill text-bg-info">{{ bpFilasParsed.length }} transacci&oacute;n(es)</span>
              </div>
            </div>
          </div>

          <!-- Resumen + tabla cruzada -->
          <div *ngIf="bpFilasCruzadas.length" class="p-3 bg-body rounded shadow-sm mb-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
              <div class="small">
                <span class="badge rounded-pill text-bg-success me-1">{{ bpResumenCruzado().conciliados }} conciliado(s)</span>
                <span class="badge rounded-pill text-bg-warning me-1">{{ bpResumenCruzado().pendientes }} pendiente(s)</span>
                <span class="badge rounded-pill text-bg-danger me-1">{{ bpResumenCruzado().noEncontrados }} no encontrado(s)</span>
                <span class="badge rounded-pill text-bg-secondary" *ngIf="bpResumenCruzado().otros">{{ bpResumenCruzado().otros }} otro(s)</span>
              </div>
              <div class="d-flex gap-2">
                <button class="btn btn-sm btn-outline-secondary" (click)="bpSeleccionarPendientes()">
                  <i class="fas fa-check-square me-1"></i> Seleccionar pendientes
                </button>
                <button class="btn btn-sm btn-outline-secondary" (click)="bpDeseleccionarTodos()"
                        [disabled]="!bpSeleccionadas.size">
                  <i class="fas fa-times me-1"></i> Deseleccionar todos
                </button>
                <button class="btn btn-sm btn-outline-info" (click)="bpSimularSeleccionados()"
                        [disabled]="!bpSeleccionadas.size || bpSimulando || bpBulkRegistrando">
                  <i class="fas fa-flask me-1"></i>
                  <span *ngIf="!bpSimulando">Simular {{ bpSeleccionadas.size }} (dry-run)</span>
                  <span *ngIf="bpSimulando">Simulando...</span>
                </button>
                <button class="btn btn-sm btn-danger" (click)="bpCrearPagosSeleccionados()"
                        [disabled]="!bpSeleccionadas.size || bpBulkRegistrando">
                  <i class="fas fa-plus-circle me-1"></i>
                  <span *ngIf="!bpBulkRegistrando">Registrar {{ bpSeleccionadas.size }} pago(s)</span>
                  <span *ngIf="bpBulkRegistrando">Procesando...</span>
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-sm align-middle">
                <thead class="small text-secondary">
                  <tr>
                    <th style="width:40px;"></th>
                    <th>Referencia</th>
                    <th>Cliente</th>
                    <th>C&eacute;dula pagador</th>
                    <th class="text-end">Monto</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let f of bpFilasCruzadas">
                    <td>
                      <input type="checkbox"
                             *ngIf="bpIsSeleccionable(f.kredit)"
                             [checked]="bpSeleccionadas.has(f.transactionNumber)"
                             (change)="bpToggleSeleccion(f.transactionNumber)" />
                    </td>
                    <td class="small">{{ f.transactionNumber }}</td>
                    <td class="small">
                      <div *ngIf="f.kredit?.personName">{{ f.kredit.personName }}</div>
                      <div class="text-secondary" *ngIf="f.kredit?.personIdentity">{{ f.kredit.personIdentity }}</div>
                      <div class="text-danger small" *ngIf="f.kredit?.status === 'NOT_FOUND'">—</div>
                    </td>
                    <td class="small">{{ f.cedula }}</td>
                    <td class="small text-end">{{ f.monto | number:'1.2-2' }}</td>
                    <td>
                      <span class="badge rounded-pill" [ngClass]="bpStatusBadge(f.kredit?.status).cls">
                        {{ bpStatusBadge(f.kredit?.status).label }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Resultado simulación (dry-run) -->
          <div *ngIf="bpSimulacionResultado" class="p-3 bg-body rounded shadow-sm mb-3 border border-info-subtle">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="fw-bold text-dark">
                <i class="fas fa-flask me-1 text-info"></i> Simulación (dry-run) — nada se ha escrito
              </div>
              <small class="text-secondary">Revisa los resultados antes de confirmar la creación real</small>
            </div>
            <div class="table-responsive">
              <table class="table table-sm align-middle">
                <thead class="small text-secondary">
                  <tr>
                    <th>Referencia</th>
                    <th>Estado</th>
                    <th>Cliente</th>
                    <th class="text-end">Monto</th>
                    <th>Cuotas</th>
                    <th>Detalle banco</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of bpSimulacionResultado.results">
                    <td class="small">{{ r.transactionNumber }}</td>
                    <td>
                      <span class="badge rounded-pill" [ngClass]="bpStatusBadge(r.status).cls">
                        {{ bpStatusBadge(r.status).label }}
                      </span>
                    </td>
                    <td class="small">{{ r.willDo?.personName || '—' }}</td>
                    <td class="small text-end">{{ r.willDo?.amount | number:'1.2-2' }}</td>
                    <td class="small">{{ r.willDo?.wouldReconcileInvoices ?? '—' }}</td>
                    <td class="small text-secondary">
                      <span *ngIf="r.willDo?.authorizationCode">Auth {{ r.willDo.authorizationCode }}</span>
                      <span *ngIf="r.reason" class="text-danger">{{ r.reason }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Resultado bulk -->
          <div *ngIf="bpBulkResultado" class="p-3 bg-body rounded shadow-sm mb-3">
            <div class="fw-bold text-dark mb-2">Resultado del registro en batch</div>
            <div class="table-responsive">
              <table class="table table-sm align-middle">
                <thead class="small text-secondary">
                  <tr>
                    <th>Referencia</th>
                    <th>Resultado</th>
                    <th>C&oacute;digo de pago</th>
                    <th>Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of bpBulkResultado.results">
                    <td class="small">{{ r.transactionNumber }}</td>
                    <td>
                      <span class="badge rounded-pill" [ngClass]="bpStatusBadge(r.status).cls">
                        {{ bpStatusBadge(r.status).label }}
                      </span>
                    </td>
                    <td class="small">{{ r.paymentCode || '—' }}</td>
                    <td class="small text-secondary">{{ r.reason || (r.invoicesPending != null ? r.invoicesPending + ' cuota(s)' : '—') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Empty state liquidación -->
          <div *ngIf="!bpFilasParsed.length" class="text-center py-5">
            <div class="mx-auto mb-3" style="width:48px;height:48px;background:#f3f4f6;border-radius:50%;display:flex;align-items:center;justify-content:center;">
              <i class="fas fa-file-excel text-secondary"></i>
            </div>
            <div class="text-dark fw-medium">Selecciona el archivo de liquidaci&oacute;n</div>
            <div class="text-secondary small">Formato esperado: columna "Referencia Afiliado" + monto + fecha</div>
          </div>
        </div>

        <!-- ===== Modal deslizante: historial / bitácora unificado ===== -->
        <div *ngIf="bpHistorialOpen" class="position-fixed top-0 end-0 h-100 bg-white shadow-lg"
             style="max-width:52rem; width:100%; z-index:1050; overflow-y:auto; border-left:1px solid #e5e7eb;">
          <div class="d-flex justify-content-between align-items-center p-3 border-bottom sticky-top bg-white">
            <div>
              <div class="fw-bold text-dark">Historial de intentos</div>
              <small class="text-secondary">Referencia afiliado {{ bpTxNumber }}</small>
              <small *ngIf="bpHistorial?.bdvIdPayment" class="text-secondary d-block">BDV payment ID: {{ bpHistorial.bdvIdPayment }}</small>
            </div>
            <button class="btn btn-sm btn-outline-secondary" (click)="bpCloseHistorial()">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="p-3" *ngIf="bpHistorialLoading">
            <div class="text-center"><img src="./assets/public/images/loading.gif" alt="" /></div>
          </div>

          <div class="p-3" *ngIf="!bpHistorialLoading && bpHistorial">
            <div class="d-flex gap-2 flex-wrap mb-3 small">
              <span class="badge rounded-pill text-bg-info">{{ bpHistorial.kreditCount || 0 }} de kredit</span>
              <span class="badge rounded-pill text-bg-secondary">{{ bpHistorial.gatewayCount || 0 }} del banco (gateway)</span>
              <span *ngIf="bpHistorial.gatewayError" class="badge rounded-pill text-bg-warning">
                gateway no accesible: {{ bpHistorial.gatewayError }}
              </span>
            </div>

            <div *ngIf="!bpHistorial.timeline?.length" class="text-center py-4 text-secondary small">
              No se encontraron bit&aacute;coras para esta referencia.
            </div>

            <div class="list-group" *ngIf="bpHistorial.timeline?.length">
              <div class="list-group-item list-group-item-action" *ngFor="let entry of bpHistorial.timeline"
                   (click)="bpToggleHistorialEntry(entry)" style="cursor:pointer;">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <div class="fw-medium small">
                      <i [ngClass]="entry.source === 'gateway' ? 'fas fa-university text-primary' : 'fas fa-database text-success'" class="me-2"></i>
                      {{ bpHistorialLabel(entry) }}
                      <span class="text-secondary ms-2">[{{ entry.source }}]</span>
                    </div>
                    <small class="text-secondary">{{ entry.date | date:'dd/MM/yyyy HH:mm:ss' }} — {{ entry.endpoint }}</small>
                  </div>
                  <div class="d-flex gap-1 align-items-center">
                    <span *ngIf="bpBankResultLabel(entry)" class="badge rounded-pill" [ngClass]="bpHistorialStatusClass(entry)">
                      {{ bpBankResultLabel(entry) }}
                    </span>
                    <span *ngIf="!bpBankResultLabel(entry)" class="badge rounded-pill" [ngClass]="bpHistorialStatusClass(entry)">
                      HTTP {{ entry.statusResponse || '—' }}
                    </span>
                    <i class="fas" [ngClass]="bpHistorialEntryExpanded === entry ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </div>
                </div>

                <div *ngIf="bpHistorialEntryExpanded === entry" class="mt-3 pt-2 border-top small"
                     (click)="$event.stopPropagation()">
                  <div *ngIf="entry.error" class="alert alert-danger py-2 small">
                    <strong>Error:</strong> {{ entry.error }}
                  </div>
                  <div class="row g-2">
                    <div class="col-md-6" *ngIf="entry.flow">
                      <span class="text-secondary">Flow:</span> {{ entry.flow }}
                    </div>
                    <div class="col-md-6" *ngIf="entry.product">
                      <span class="text-secondary">Product:</span> {{ entry.product }}
                    </div>
                    <div class="col-md-6" *ngIf="entry.amount">
                      <span class="text-secondary">Amount:</span> {{ entry.amount | number:'1.2-2' }}
                    </div>
                    <div class="col-md-6" *ngIf="entry.statusResponseIntegration != null">
                      <span class="text-secondary">Status banco:</span> {{ entry.statusResponseIntegration }}
                    </div>
                    <div class="col-md-12" *ngIf="entry.integrationEndpoint">
                      <span class="text-secondary">Integration endpoint:</span>
                      <code class="small">{{ entry.integrationEndpoint }}</code>
                    </div>
                  </div>

                  <details class="mt-2" *ngIf="entry.requestBody || entry.requestBodyIntegration">
                    <summary class="text-secondary">Request</summary>
                    <pre class="bg-light p-2 rounded mt-1" style="max-height:200px;overflow:auto;font-size:0.75rem;">{{ (entry.requestBodyIntegration || entry.requestBody) | json }}</pre>
                  </details>
                  <details class="mt-2" *ngIf="entry.responseBody || entry.responseBodyIntegration">
                    <summary class="text-secondary">Response</summary>
                    <pre class="bg-light p-2 rounded mt-1" style="max-height:200px;overflow:auto;font-size:0.75rem;">{{ (entry.responseBodyIntegration || entry.responseBody) | json }}</pre>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== Modal deslizante: detalle de pago ===== -->
        <!-- ===== Modal custom: confirmar Registrar Pago ===== -->
        <div *ngIf="bpConfirmOpen"
             class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
             style="background:rgba(0,0,0,0.5); z-index:1060;"
             (click)="bpCerrarConfirm()">
          <div class="bg-white rounded shadow-lg" style="max-width:480px; width:90%;" (click)="$event.stopPropagation()">
            <div class="p-4 border-bottom" style="background:linear-gradient(to right, #dc3545, #b02a37); color:white; border-radius:.25rem .25rem 0 0;">
              <div class="d-flex align-items-center gap-2">
                <i class="fas fa-exclamation-circle fa-lg"></i>
                <h5 class="mb-0 fw-bold">Confirmar registro de pago</h5>
              </div>
            </div>
            <div class="p-4">
              <p class="mb-2">Estás a punto de registrar un pago para la transacci&oacute;n:</p>
              <div class="p-3 bg-body rounded mb-3">
                <div class="small text-secondary">Referencia afiliado</div>
                <div class="fw-bold text-dark fs-5">{{ bpTxNumber }}</div>
                <div class="small text-secondary mt-2" *ngIf="bpResultado?.personName">
                  {{ bpResultado.personName }}
                  <span *ngIf="bpResultado.personIdentity">— C.I. {{ bpResultado.personIdentity }}</span>
                </div>
                <div class="small" *ngIf="bpResultado?.amount != null">
                  <span class="text-secondary">Monto:</span> <strong>{{ bpResultado.amount | number:'1.2-2' }} Bs.</strong>
                </div>
                <div class="small" *ngIf="bpVerificacion?.detail?.authorizationCode">
                  <span class="text-secondary">C&oacute;d. autorizaci&oacute;n banco:</span> <strong>{{ bpVerificacion.detail.authorizationCode }}</strong>
                </div>
              </div>
              <div class="alert alert-warning small mb-3 py-2">
                <i class="fas fa-exclamation-triangle me-1"></i>
                Esta operaci&oacute;n <strong>escribe en PRODUCCI&Oacute;N</strong> y quedar&aacute; registrada como
                <strong>{{ bpConfirmUserEmail }}</strong>.
              </div>
              <div class="small text-secondary">
                El proceso verifica con el banco, crea el pago y concilia las cuotas. Puede tardar 1-2 minutos.
              </div>
            </div>
            <div class="p-3 border-top d-flex justify-content-end gap-2">
              <button class="btn btn-outline-secondary btn-sm" (click)="bpCerrarConfirm()">
                <i class="fas fa-times me-1"></i> Cancelar
              </button>
              <button class="btn btn-danger btn-sm" (click)="bpConfirmarYRegistrar()">
                <i class="fas fa-check me-1"></i> S&iacute;, registrar pago
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="bpPaymentDetailOpen" class="position-fixed top-0 end-0 h-100 bg-white shadow-lg"
             style="max-width:48rem; width:100%; z-index:1050; overflow-y:auto; border-left:1px solid #e5e7eb;">
          <div class="d-flex justify-content-between align-items-center p-3 border-bottom sticky-top bg-white">
            <div>
              <div class="fw-bold text-dark">Detalle del pago</div>
              <small class="text-secondary">C&oacute;digo: {{ bpPaymentDetail?.payment?.code || '—' }}</small>
            </div>
            <button class="btn btn-sm btn-outline-secondary" (click)="bpClosePaymentDetail()">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="p-3" *ngIf="bpLoadingDetail">
            <div class="text-center">
              <img src="./assets/public/images/loading.gif" alt="" />
            </div>
          </div>

          <div class="p-3" *ngIf="!bpLoadingDetail && bpPaymentDetail">
            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <div class="text-secondary small">C&oacute;digo</div>
                <div class="fw-bold text-dark small">{{ bpPaymentDetail.payment?.code || '—' }}</div>
              </div>
              <div class="col-md-6 text-md-end">
                <div class="text-secondary small">Monto total</div>
                <div class="fw-bold text-dark">{{ bpPaymentDetail.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
              </div>

              <div class="col-md-6">
                <div class="text-secondary small">Estado</div>
                <div>
                  <span *ngIf="bpPaymentDetail.payment?.reconciled_payment && bpPaymentDetail.payment?.status"
                        class="badge rounded-pill text-bg-success">Conciliado</span>
                  <span *ngIf="!bpPaymentDetail.payment?.reconciled_payment && bpPaymentDetail.payment?.status"
                        class="badge rounded-pill text-bg-warning">Por conciliar</span>
                  <span *ngIf="!bpPaymentDetail.payment?.status"
                        class="badge rounded-pill text-bg-danger">Anulado</span>
                </div>
              </div>
              <div class="col-md-6 text-md-end">
                <div class="text-secondary small">Tasa de cambio</div>
                <div class="fw-bold text-dark small">USD 1 = BS {{ bpPaymentDetail.payment?.rate | number:'1.2-2' }}</div>
              </div>

              <div class="col-md-6">
                <div class="text-secondary small">Monto del pago</div>
                <div class="fw-bold text-dark">{{ bpPaymentDetail.payment?.counterValue | number:'1.2-2' }} {{ bpPaymentDetail.payment?.currency?.name || 'Bs' }}</div>
              </div>
              <div class="col-md-6 text-md-end">
                <div class="text-secondary small">Fecha de reporte</div>
                <div class="fw-bold text-dark small">{{ bpPaymentDetail.payment?.date | date:'dd/MM/yyyy h:mm:ss a' }}</div>
              </div>

              <div class="col-md-6">
                <div class="text-secondary small">M&eacute;todo de pago</div>
                <div class="fw-bold text-dark small">{{ bpPaymentDetail.payment?.account_payment?.payment_method?.name || '—' }}</div>
              </div>
              <div class="col-md-6 text-md-end">
                <div class="text-secondary small">Referencia banco</div>
                <div class="fw-bold text-dark small">
                  <a *ngIf="bpPaymentDetail.payment?.paymentMethodId"
                     href="javascript:void(0)"
                     class="text-decoration-none text-primary"
                     title="Click para copiar"
                     (click)="bpCopyToClipboard(bpPaymentDetail.payment.paymentMethodId, 'Referencia banco')">
                    {{ bpPaymentDetail.payment.paymentMethodId }}
                    <i class="fas fa-copy ms-1" style="font-size:0.7rem;"></i>
                  </a>
                  <span *ngIf="!bpPaymentDetail.payment?.paymentMethodId">—</span>
                </div>
              </div>

              <div class="col-12" *ngIf="bpPaymentDetail.payment?.account_payment?.account">
                <div class="text-secondary small">Cuenta dep&oacute;sito</div>
                <div class="fw-bold text-dark small">{{ bpPaymentDetail.payment.account_payment.account }}</div>
              </div>
            </div>

            <div *ngIf="bpPaymentDetail.installMent?.length" class="mb-3 pt-3 border-top">
              <div class="fw-bold text-dark small mb-2">
                <i class="fas fa-list-ol me-1"></i>
                Cuotas conciliadas ({{ bpPaymentDetail.installMent.length }})
              </div>
              <div class="p-2 bg-body rounded small mb-1" *ngFor="let item of bpPaymentDetail.installMent">
                <div class="d-flex justify-content-between">
                  <span>
                    <strong>{{ item?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item?.installMent?.order }}</strong>
                    <span *ngIf="item?.installMent?.invoice?.identifier" class="text-secondary ms-2">
                      — {{ item.installMent.invoice.identifier }}
                    </span>
                  </span>
                  <span class="text-success fw-medium">{{ item.amount | number:'1.2-2' }} USD</span>
                </div>
              </div>
            </div>

            <div *ngIf="bpPaymentDetail.fees?.length" class="mb-3 pt-3 border-top">
              <div class="fw-bold text-dark small mb-2">Fees ({{ bpPaymentDetail.fees.length }})</div>
              <div class="p-2 bg-body rounded small mb-1" *ngFor="let f of bpPaymentDetail.fees">
                <div class="d-flex justify-content-between">
                  <span>{{ f.description || f.name || 'Fee' }}</span>
                  <span>{{ f.amount | number:'1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
